<section class="mx-auto max-w-page px-4 py-10 sm:px-6 lg:px-8">
  <div class="flex flex-col gap-8">
    <header class="flex flex-col gap-2">
      <h1 class="text-h4 text-slate-950">Your forms</h1>
      <p class="text-body2 text-slate-500">
        Forms shared with your email appear here, including upcoming releases.
      </p>
    </header>

    <div class="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div class="w-full sm:max-w-md">
        <lib-signal-text-field
          label=""
          placeholder="Search by form or workspace"
          prefixIcon="assets/icons/search.svg"
          fillColor="#ffffff"
          [value]="searchQuery()"
          [debounceValueChange]="false"
          (valueChange)="onSearchValueChange($event)" />
      </div>

      <div class="w-full sm:w-56">
        <lib-signal-dropdown
          label=""
          placeholder="All workspaces"
          fillColor="#ffffff"
          [items]="workspaceDropdownItems()"
          valuePath="id"
          displayPath="name"
          [value]="workspaceFilter()"
          [debounceValueChange]="false"
          (valueChange)="onWorkspaceFilterChange($event)" />
      </div>
    </div>

    @if (listState.loading() && forms().length === 0) {
      <div class="grid gap-4">
        @for (_ of [1, 2, 3]; track $index) {
          <div class="animate-pulse rounded-2xl border border-slate-200 bg-white p-5 sm:p-6">
            <div class="flex items-start gap-4">
              <div class="h-11 w-11 shrink-0 rounded-xl bg-slate-100"></div>
              <div class="min-w-0 flex-1 space-y-3">
                <div class="h-4 w-2/5 rounded bg-slate-100"></div>
                <div class="h-3 w-1/4 rounded bg-slate-100"></div>
                <div class="h-3 w-3/4 rounded bg-slate-100"></div>
              </div>
            </div>
          </div>
        }
      </div>
    } @else if (filteredForms().length === 0) {
      <div
        class="flex flex-col items-center justify-center gap-3 rounded-2xl border border-slate-200 bg-white px-6 py-16 text-center">
        <span
          class="flex h-12 w-12 items-center justify-center rounded-full bg-slate-50 text-slate-500"
          aria-hidden="true">
          <app-svg-icon src="assets/icons/file-document-outline.svg" [size]="24" />
        </span>
        @if (forms().length === 0) {
          <h2 class="text-base font-semibold text-slate-900">
            No forms shared with you yet
          </h2>
          <p class="max-w-sm text-sm text-slate-500">
            When a workspace invites your email to a form, it will show up here.
          </p>
        } @else {
          <h2 class="text-base font-semibold text-slate-900">No matching forms</h2>
          <p class="max-w-sm text-sm text-slate-500">
            Try a different search term.
          </p>
        }
      </div>
    } @else {
      <div class="grid gap-4">
        @for (form of filteredForms(); track form.id) {
          <article
            class="flex flex-col gap-4 rounded-2xl border bg-white p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6"
            [class.border-slate-200]="form.availability === 'available'"
            [class.border-slate-200/80]="form.availability === 'not_yet_available'"
            [class.bg-slate-50/60]="form.availability === 'not_yet_available'">
            <div class="flex min-w-0 items-start gap-4">
              @if (form.availability === 'available') {
                <span
                  class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-sky-50 text-sky-600"
                  aria-hidden="true">
                  <app-svg-icon src="assets/icons/file-document-outline.svg" [size]="22" />
                </span>
              } @else {
                <span
                  class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-50 text-amber-600"
                  aria-hidden="true">
                  <app-svg-icon src="assets/icons/clock-outline.svg" [size]="22" />
                </span>
              }
              <div class="min-w-0">
                <h2 class="truncate text-base font-semibold text-slate-950">
                  {{ form.name }}
                </h2>
                <p class="mt-1 text-sm text-slate-500">
                  {{ form.workspaceName }}
                  @if (form.availability === 'available') {
                    <span class="text-slate-300">·</span>
                    Updated {{ form.updatedAt | date: 'mediumDate' }}
                  }
                </p>
                @if (form.availability === 'not_yet_available' && form.availableAt) {
                  <p class="mt-1 text-sm font-medium text-amber-800">
                    Available from {{ form.availableAt | date: 'medium' }}
                  </p>
                }
                @if (form.description) {
                  <p class="mt-2 line-clamp-2 text-sm leading-5 text-slate-500">
                    {{ form.description }}
                  </p>
                }
              </div>
            </div>

            <div class="shrink-0 sm:pl-4">
              @if (form.availability === 'available') {
                <lib-signal-button [fullWidth]="false" (clicked)="openForm(form)">
                  Open
                </lib-signal-button>
              } @else {
                <lib-signal-button
                  appearance="outline"
                  [fullWidth]="false"
                  (clicked)="openForm(form)">
                  View
                </lib-signal-button>
              }
            </div>
          </article>
        }
      </div>
    }
  </div>
</section>
